import styled from "@emotion/styled"

export default styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
`
